import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Homepage from './pages/Homepage';
import Portfolio from './pages/Portfolio';
import Focus from './pages/Focus';
import Platform from './pages/Platform';
import Team from './pages/Team';
import ForFounders from './pages/ForFounders';
import Insights from './pages/Insights';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="min-h-screen">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/focus" element={<Focus />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/team" element={<Team />} />
            <Route path="/for-founders" element={<ForFounders />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;